// Default site content — single source of truth for both frontend and backend seed.
// Backend seeds the same values into MongoDB on first startup; the CMS at /admin/content
// edits that document, and the frontend reads it on mount with these as fallbacks.

export const DEFAULT_CONTENT = {
  id: "main",
  contact: {
    phone: "07842 532224",
    email: "simon@fourbeesconsultancy.co.uk",
    linkedin: "https://www.linkedin.com/in/simon-sammut-a66b87281",
    location: "Essex, United Kingdom",
    founderName: "Simon",
    founderRole: "Founder & Consultant",
  },
  founderPhoto:
    "https://customer-assets-39nsmqrw.emergentagent.net/job_ff3c1b3a-42c9-479d-bdd9-90b7771dd0c6/artifacts/07f4ef11565efd52_20260911_133814306_iOS.jpg",
  home: {
    heroEyebrow: "Fourbees Consultancy — Essex, UK",
    heroHeadline: "Practical Expertise.",
    heroHeadlineAccent: "Stronger Businesses.",
    heroSub:
      "From the milk round to the office, Fourbees Consultancy helps independent dairies and growing businesses improve operations, reach new customers and build for the future.",
    credibilityHeadline: "Over 15 years of hands-on doorstep dairy experience.",
    credibilityBody:
      "Not a desk-based consultancy. Real industry background, honest advice, and a focus on what actually moves the needle for small British businesses.",
  },
  services: [
    {
      slug: "dairy-business-consultancy",
      index: "01",
      title: "Dairy Business Consultancy",
      short:
        "Support with daily operations, business processes, customer retention, expansion and practical problem-solving for independent dairies.",
      long:
        "Running a doorstep dairy means wearing a dozen hats before most people have had their first cup of tea. We work alongside independent dairies and family-run businesses to look at how things are running day to day — and where small, practical changes make the biggest difference.\n\nThat usually covers customer retention, pricing and product mix, team structure, day-to-day processes and the long-standing bottlenecks that quietly cost money. We give honest, straightforward advice. No glossy decks, no filler.",
    },
    {
      slug: "route-planning",
      index: "02",
      title: "Route Planning & Operational Efficiency",
      short:
        "Help with delivery round organisation, route efficiency, delivery schedules and reducing unnecessary operational costs.",
      long:
        "Round efficiency is almost always where the quickest wins sit. We review how rounds are currently structured — drop density, sequencing, timings, cross-overs — and work with you on a cleaner plan that respects long-standing customers and existing driver preferences.\n\nThe goal is a lower cost per drop, better delivery times, and rounds that are easier to cover when someone's off.",
    },
    {
      slug: "social-media-management",
      index: "03",
      title: "Social Media Management",
      short:
        "Professional management of Facebook and other suitable platforms, including content planning, customer engagement and maintaining a consistent online presence.",
      long:
        "Most of your potential new customers live within a mile or two of the round. Facebook is still where they talk to each other — village groups, local pages, parish chatter. We manage that presence on your behalf: regular, well-written posts, replies to comments and messages, and a tone of voice that sounds like a real local business rather than a marketing agency.\n\nYou stay focused on the deliveries. We keep the online side looking after itself.",
    },
    {
      slug: "website-design",
      index: "04",
      title: "Website Design & Development",
      short:
        "Professional, mobile-friendly websites for independent dairies and small businesses, with clear service information, enquiry forms and local search visibility.",
      long:
        "Independent dairies don't need the website a London tech start-up needs. They need something clean, trustworthy, mobile-friendly, and quick to load. Something that explains clearly what you deliver, where you deliver, how to order, and gives potential customers a simple way to get in touch.\n\nWe design and build exactly that — including the practical bits like local search visibility, contact forms that actually arrive in your inbox, and content that reads naturally.",
    },
    {
      slug: "local-advertising",
      index: "05",
      title: "Local Advertising & Customer Growth",
      short:
        "Targeted local Facebook campaigns, promotional content and customer acquisition strategies designed to help milkmen attract new households to their rounds.",
      long:
        "Targeted local advertising on Facebook remains the single most cost-effective way for most dairies to find new customers. We plan the campaigns, write the copy, design the creative and manage the spend — focused tightly on the postcodes you actually deliver to.\n\nWe don't promise guaranteed sign-ups. We do commit to clear reporting, honest reviews of what's working, and ongoing adjustments to keep the enquiries coming in.",
    },
    {
      slug: "mds-admin",
      index: "06",
      title: "MDS, Invoicing & Administration",
      short:
        "Practical assistance with dairy management systems, billing processes, customer accounts and administrative organisation.",
      long:
        "MDS (Milk Delivery System) is a powerful piece of software, but it rewards knowing how to use it properly. We help with set-up, workflows, training new staff, and the quiet admin tasks — invoicing, accounts, exception handling — that eat into evenings when they're not organised well.\n\nThe goal: fewer late nights at the laptop, cleaner books, and more time back for the business.",
    },
    {
      slug: "transport-logistics",
      index: "07",
      title: "Transport & Logistics Consultancy",
      short:
        "Support with transport operations, route efficiency, delivery planning and general logistics — drawing on hands-on transport experience alongside dairy work.",
      long:
        "Our experience isn't limited to dairy. We've worked across transport and logistics operations and bring that practical background to small delivery businesses more broadly — vehicle utilisation, route planning, driver scheduling, and the operational detail that doesn't make it onto spreadsheets.\n\nIf you deliver on wheels, we can usually help.",
    },
  ],
};
